import './TabLayout.scss';

const TabLayout = ({ tabs, activeKey, onChange, variant = 'underline' }) => (
  // variant = 'background' || 'underline'
  <div id="tablayout-request-container" className={`variant-${variant}`}>
    <div className="tablayout-request-tab">
      {tabs.map((tab) => (
        <div
          key={tab.key}
          className={`tab ${activeKey === tab.key ? 'active' : ''}`}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
        </div>
      ))}
    </div>
  </div>
);

export default TabLayout;
